import Navbar from '@/components/feature/Navbar';
import IndustriesSection from '@/pages/home/components/IndustriesSection';
import CTASection from '@/pages/home/components/CTASection';
import Footer from '@/components/feature/Footer';

export default function IndustriesPage() {
  return (
    <main>
      <Navbar />
      <div className="h-20"></div>
      <IndustriesSection />
      <CTASection />
      <Footer />
    </main>
  );
}